export default __webpack_public_path__ + "static/media/RGB_BCA_AUTOENCHERES.6a511904.svg";